import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';

import { useCommendaAiHost } from './CommendaAiHostProvider';

export const useChatFolderUpload = (): boolean => {
  const { companyId } = useCommendaAiHost();

  return isFeatureLaunched(
    FeatureLaunch.CHAT_FOLDER_UPLOAD,
    companyId ?? undefined
  );
};
